import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import DTQuestionOrInstructionView from '../../DTQuestionOrInstructionView';
import ButtonList from '../../Common/ButtonList/ButtonList';
import * as colors from '../../../../../common/colorConstants';
import { trackDecisionTreeTrackingLinkClicked } from '../../../../../../analytics/searchEventAnalytics';
import { getDecisionNodeAtPath } from '../../../../../../extractFromState';
import { ExpertQuestionSection, SubText, SubTextLink, Title } from '../../DTQuestionOrInstruction.styles';

const DTExpertLinkQuestionNode = () => {
  const decisionNode = useSelector(getDecisionNodeAtPath);
  const [isLinkClicked, setIsLinkClicked] = useState(false);

  useEffect(() => {
    setIsLinkClicked(false);
  }, [decisionNode?.title, setIsLinkClicked]);

  const handleLinkClick = () => {
    setIsLinkClicked(true);
    trackDecisionTreeTrackingLinkClicked();
  };

  const renderQuestion = () => (
    <ExpertQuestionSection>
      {decisionNode?.title && <Title>{decisionNode.title}</Title>}
      {decisionNode?.subText && <SubText>{decisionNode.subText}</SubText>}
      <SubTextLink>
        <a
          onClick={handleLinkClick}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: colors.darkGray9 }}
          href={decisionNode?.link}
        >
          Click on this link
        </a>
      </SubTextLink>
    </ExpertQuestionSection>
  );

  return (
    <DTQuestionOrInstructionView
      titleSection={renderQuestion()}
      options={<ButtonList isButtonDisabled={!isLinkClicked} />}
      loading={false}
    />
  );
};

export default DTExpertLinkQuestionNode;
